import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AdminExportPage } from "./pages/admin/AdminExportPage";
import { AdminImportPage } from "./pages/admin/AdminImportPage";
import { AdminOverviewPage } from "./pages/admin/AdminOverviewPage";
import { AdminUsersPage } from "./pages/admin/AdminUsersPage";
import { CapturePage } from "./pages/CapturePage";
import { DashboardPage } from "./pages/DashboardPage";
import { HistoryPage } from "./pages/HistoryPage";
import { LoginPage } from "./pages/LoginPage";
import { MatchReviewPage } from "./pages/MatchReviewPage";
import { ReceiptDetailPage } from "./pages/ReceiptDetailPage";
import { ShareSetupPage } from "./pages/ShareSetupPage";
import { TransactionDetailPage } from "./pages/TransactionDetailPage";
import { useAuth } from "./store/auth";
import { registerPush } from "./lib/push";

function HomeRedirect() {
  const user = useAuth((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/"} replace />;
}

export default function App() {
  const bootstrap = useAuth((s) => s.bootstrap);
  const user = useAuth((s) => s.user);

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  useEffect(() => {
    if (user) void registerPush();
  }, [user]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/capture" element={<CapturePage />} />
        <Route path="/share-setup" element={<ShareSetupPage />} />
        <Route path="/receipts/:id" element={<ReceiptDetailPage />} />
        <Route path="/match" element={<MatchReviewPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/transactions/:id" element={<TransactionDetailPage />} />
      </Route>

      <Route element={<ProtectedRoute adminOnly />}>
        <Route path="/admin" element={<AdminOverviewPage />} />
        <Route path="/admin/import" element={<AdminImportPage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/export" element={<AdminExportPage />} />
      </Route>

      <Route path="*" element={<HomeRedirect />} />
    </Routes>
  );
}
